import { motion } from "framer-motion";

const painSignals = [
  "Podés tener mejores capacidades y seguir siendo comparado por precio.",
  "Podés haber evolucionado y seguir siendo reconocido por lo que eras.",
  "Podés tener diferenciales que existen, pero que el mercado no logra ver.",
  "Podés crecer mientras el valor sigue concentrado en el founder, una marca o un producto.",
];

const CapitalDilution = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden bg-background">
      <div className="container px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-foreground leading-tight">
            Cuando tu percepción queda atrás,{" "}
            <span className="text-gradient-gold">tu empresa también deja valor sobre la mesa</span>.
          </h2>
        </motion.div>

        {/* Signals grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16">
          {painSignals.map((signal, index) => (
            <motion.div
              key={signal}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="p-8 rounded-2xl border border-border bg-card hover:border-primary/40 transition-colors duration-300"
            >
              <p className="text-lg text-foreground leading-relaxed font-medium">
                {signal}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Closing statement */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          <div className="rounded-2xl border border-primary/30 bg-primary/5 p-8 md:p-10">
            <p className="text-lg md:text-xl text-foreground leading-relaxed font-display font-medium">
              El valor que no se hace perceptible es valor que se diluye.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CapitalDilution;
